export const PCM_WORKLET_SOURCE = `
class PcmCaptureProcessor extends AudioWorkletProcessor {
    process(inputs) {
        const input = inputs[0];
        if (input && input[0] && input[0].length > 0) {
            this.port.postMessage(input[0].slice(0));
        }
        return true;
    }
}
registerProcessor('pcm-capture', PcmCaptureProcessor);
`;

export function floatToPcm16(samples: Float32Array): Int16Array {
    return Int16Array.from(samples, sample => Math.round(Math.max(-1, Math.min(1, sample)) * 0x7fff));
}
